module.exports = __webpack_public_path__ + "img/20.d9f38181.jpg";